import React, { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  canAccessAdmissionPath,
  defaultAdmissionRedirect,
} from "../utils/admissionAccess";

interface Props {
  children: ReactNode;
}

const AdmissionRouteGuard: React.FC<Props> = ({ children }) => {
  const location = useLocation();
  const { signinuser } = useSelector((state: any) => state.common);

  if (
    !canAccessAdmissionPath(
      signinuser,
      location.pathname,
      location.state,
    )
  ) {
    return (
      <Navigate to={defaultAdmissionRedirect(signinuser)} replace />
    );
  }

  return <>{children}</>;
};

export default AdmissionRouteGuard;
